import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import FullPage from '@/src/components/UI/FullPage';
import useT from '@/lib/t';

const Cookies = () => {
  const t = useT();
  return (
    <FullPage hasHeaderPlaceHolder title={t('share.header.cookies')} text={''}>
      <p className='text-2xl leading-loose font-medium text-gray900  uppercase mb-10'>FUNWOO Cookie 使用者條款</p>
      <p className=' leading-normal tracking-wide mb-6 text-gray800'>
        為了提供您更好的賣/買屋交易體驗，本官網有使用
        Cookies。如果您繼續瀏覽或使用本官網各項服務，就表示您同意我們以下的 Cookies 使用者條款。
      </p>
      <p className='text-xl leading-normal font-bold text-dark-grey mb-5 text-gray900'>Cookies使用者條款</p>
      <p className='text-lg leading-loose font-medium mb-4'>Cookie 是什麼？</p>
      <p className=' leading-normal tracking-wide whitespace-pre-wrap text-gray800'>
        {`當您瀏覽或使用 FUNWOO網站(以下稱「本官網」)時，我們會在您的裝置中(電腦、手機、平板電腦或任何其他行動裝置)儲存少量資料，一般稱之為Cookie，目的是協助我們辨識出相同的使用者。這些 Cookie ，在您下次造訪我們官網之前，仍會保留在您的裝置上，直到它們過期或被刪除為止。\n\n我們使用各種 Cookie，以維持我們官網的基本運作、評估和分析網站流量，並維持網站的穩定。有些 Cookie會收集您的選擇和偏好，以及您使用網站及服務內容的相關資訊；這些資訊，有助於我們改善網站的功能。舉例來說，透過Cookie 的設置，我們能得知官網最常被瀏覽的頁面、記錄您瀏覽網站時遇到的任何問題。\n\n此外，我們也可能會使用Cookie，在第三方網站上向您行銷 FUNWOO服務，或評估和追蹤我們行銷活動的成效，以便更有效地設計並投放廣告。 一般來說，透過 Cookie提供給第三方網站的資訊，並不會包含您的個人資訊，而且Cookie數據通常是加密的。`}
      </p>
      <p className='text-lg leading-loose font-medium my-4 text-gray800'>如何管理 Cookie？</p>
      <p className=' leading-normal tracking-wide mb-10 text-gray800'>
        您可以參閱各瀏覽器的說明文件，透過瀏覽器的設定，來管理、停用或移除
        Cookie。不過，這麼做以後，您可能會無法有效且順暢地使用我們的服務。
      </p>
    </FullPage>
  );
};
export default Cookies;

export const getStaticProps = async ({ locale }: { locale: string }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
};
